export const MetricsCard = ({ title, value, unit }) => {
  return (
    <article className="flex flex-col flex-1 items-start  bg-[#FDFDFD] rounded-xl border border-gray-200  min-w-[200px]">
      <div className="flex flex-col gap-0.5 w-full">
        <h3 className="flex-1 gap-4 px-5 pt-3 pb-2 text-sm font-semibold leading-5 text-gray-900">
          {title}
        </h3>
        <div className="flex flex-col gap-5 p-5 bg-white rounded-xl border border-gray-200 ">
          <div className="flex flex-wrap gap-3 items-baseline">
            <span className="text-xl leading-8 text-gray-900">{value}</span>
            {unit && (
              <span className="gap-2 text-sm font-medium leading-5 text-gray-600">
                {unit}
              </span>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export const MetricsGrid = () => {
  return (
    <section className="flex flex-col gap-6 px-8">
      <div className="flex flex-wrap gap-6 items-start">
        <MetricsCard title="AI Suitability Score" value="95" unit="%" />
        <MetricsCard title="Strength" value="95" unit="%" />
        <MetricsCard title="Point of Concern" value="95" unit="%" />
        <MetricsCard title="Date Applied" value="Jan 30, 2025" />
        <MetricsCard title="Application Status" value="Shortlisted" />
      </div>
    </section>
  );
};
